/**
 * Canonical public site that hosts Truebend's legal + support pages.
 *
 * These MUST be absolute https URLs. Inside the iOS Capacitor shell the app is
 * served from capacitor://localhost, so a relative "/support.html" resolves to
 * capacitor://localhost/support.html — which the system browser cannot open, so
 * the link silently does nothing on device. Absolute https URLs open in Safari
 * on native and in a new tab on the web.
 */
export const PUBLIC_WEB_ORIGIN = 'https://bend.509electric.com';

export const LEGAL_LINKS = {
  support: `${PUBLIC_WEB_ORIGIN}/support.html`,
  privacy: `${PUBLIC_WEB_ORIGIN}/privacy.html`,
  terms: `${PUBLIC_WEB_ORIGIN}/terms.html`,
} as const;
